import React from 'react'
import Modal from 'react-modal'
import { Route, Routes } from 'react-router-dom'
import css from './App.module.css'
import Footer from './components/Footer/Footer'
// import Form from './components/Form/Form'
import Header from './components/Header/Header'
import ErrorPage from './components/ErrorPage/ErrorPage'
// import ModalFormButtonClose from './images/ModalFormButtonClose.svg'
// import ModalFormButtonOpen from './images/ModalFormOpen.svg'
// import Cennik from './pages/Cennik'
import Kontakt from './pages/Kontakt'
import ONas from './pages/ONas'
import Oferta from './pages/Oferta'
import PrivacyPolicy from './pages/PrivacyPolicy'
import StronaGlowna from './pages/StronaGlowna'
import UmowSie from './pages/UmowSie'

Modal.setAppElement('#root')

export const App = () => {
	// const [modalIsOpen, setModalIsOpen] = useState(false)
	// const toggleModal = () => setModalIsOpen(!modalIsOpen)

	return (
		<div className={css.app}>
			<Header />
			<Routes>
				<Route path='/' element={<StronaGlowna />} />

				{/* <Route path='/strona-glòwna' element={<StronaGlowna />} /> */}
				<Route path='/o-nas' element={<ONas />} />
				<Route path='/oferta' element={<Oferta />} />
				{/*<Route path='/cennik' element={<Cennik />} />*/}
				<Route path='/kontakt' element={<Kontakt />} />
				<Route path='/umów-się' element={<UmowSie />} />
				<Route path='/privacy-policy' element={<PrivacyPolicy />} />
				<Route path="*" element={<ErrorPage />} />
			</Routes>

			{/* <button className={css.fixedButton} onClick={toggleModal}>
				<img
					className={css.fixedImg}
					src={modalIsOpen ? ModalFormButtonClose : ModalFormButtonOpen}
					alt={modalIsOpen ? 'Close Modal' : 'Open Modal'}
				/>
			</button> */}

			{/* <Modal
				isOpen={modalIsOpen}
				onRequestClose={toggleModal}
				contentLabel='Modal'
				className={css.modalContent}
				overlayClassName={css.modalOverlay}
			> */}
			{/* <Form /> */}
			{/* </Modal> */}
			<Footer />
		</div>
	)
}
